// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnterOutlinedSvg from "@ant-design/icons-svg/es/asn/EnterOutlined";
import AntdIcon from '../components/AntdIcon';

var EnterOutlined = function EnterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnterOutlinedSvg
  }));
};

EnterOutlined.displayName = 'EnterOutlined';
export default React.forwardRef(EnterOutlined);